(() => {
  const DEFAULT_RECOMMEND_ENDPOINT = 'https://jev.rugsflooring.com.au/hub/recommend';

  document.querySelectorAll('[data-rf-floorboards-hub]').forEach((hub) => {
    const selector = hub.querySelector('[data-selector]');
    const form = hub.querySelector('[data-selector-form]');
    const questions = [...hub.querySelectorAll('[data-question]')];
    const results = hub.querySelector('[data-selector-results]');
    const error = hub.querySelector('[data-selector-error]');
    const heading = hub.querySelector('[data-selector-heading]');
    const progress = hub.querySelector('[data-selector-progress]');
    const back = hub.querySelector('[data-selector-back]');
    const next = hub.querySelector('[data-selector-next]');
    const review = hub.querySelector('[data-selector-review]');
    const reviewList = hub.querySelector('[data-selector-review-list]');
    const reviewMobileToggle = hub.querySelector('[data-review-mobile-toggle]');
    const reviewMobileCount = hub.querySelector('[data-review-mobile-count]');
    const reviewMobileAction = hub.querySelector('[data-review-mobile-action]');
    const scoreDebugBody = hub.querySelector('[data-score-debug-body]');
    const recommendationEndpoint = hub.dataset.recommendEndpoint || DEFAULT_RECOMMEND_ENDPOINT;

    if (!selector || !form || !questions.length || !results || !error || !heading || !progress || !back || !next || !review || !reviewList) return;

    let step = 0;
    let editingFromReview = false;
    let returnToResults = false;
    let returnStep = 0;

    const questionAnswer = (question) => {
      const checked = [...question.querySelectorAll('input:checked')];
      if (!checked.length) return null;
      return {
        question: question.querySelector('legend')?.textContent.trim() || '',
        answers: checked.map((input) => input.nextElementSibling?.textContent.trim() || input.value).filter(Boolean)
      };
    };

    const renderReview = (includeCurrent = false) => {
      const answered = questions
        .map((question, index) => ({ index, answer: questionAnswer(question) }))
        .filter((item) => item.answer && (includeCurrent || item.index !== step));

      review.hidden = answered.length === 0;
      if (reviewMobileCount) reviewMobileCount.textContent = `${answered.length} ${answered.length === 1 ? 'answer' : 'answers'} completed`;
      reviewList.replaceChildren(...answered.map((item) => {
        const row = document.createElement('div');
        row.className = 'rf-fbh__review-row';

        const copy = document.createElement('div');
        copy.className = 'rf-fbh__review-copy';
        const label = document.createElement('strong');
        label.textContent = item.answer.question;
        const value = document.createElement('span');
        value.textContent = item.answer.answers.join(', ');
        copy.append(label, value);

        const edit = document.createElement('button');
        edit.type = 'button';
        edit.className = 'rf-fbh__text-button';
        edit.textContent = 'Edit';
        edit.dataset.selectorEdit = String(item.index);
        edit.setAttribute('aria-label', `Edit answer for ${item.answer.question}`);

        row.append(copy, edit);
        return row;
      }));
    };

    const renderScoreDebug = () => {
      if (!scoreDebugBody) return;
      const row = document.createElement('tr');
      const cell = document.createElement('td');
      cell.colSpan = 9;
      cell.textContent = 'Recommendation scoring runs server-side and is not exposed in storefront JavaScript.';
      row.append(cell);
      scoreDebugBody.replaceChildren(row);
    };

    const showStep = (index) => {
      step = Math.max(0, Math.min(index, questions.length - 1));
      questions.forEach((question, questionIndex) => { question.hidden = questionIndex !== step; });
      heading.textContent = `Question ${step + 1} of ${questions.length}`;
      progress.style.width = `${((step + 1) / questions.length) * 100}%`;
      back.disabled = step === 0 && !editingFromReview;
      next.textContent = editingFromReview ? 'Save change' : (step === questions.length - 1 ? 'See my matches' : 'Next');
      error.hidden = true;
      review.classList.add('is-mobile-collapsed');
      reviewMobileToggle?.setAttribute('aria-expanded', 'false');
      if (reviewMobileAction) reviewMobileAction.textContent = 'Review';
      renderReview();
      renderScoreDebug();
      questions[step].querySelector('input')?.focus();
    };

    const reset = () => {
      editingFromReview = false;
      returnToResults = false;
      returnStep = 0;
      form.reset();
      results.hidden = true;
      form.hidden = false;
      selector.hidden = false;
      showStep(0);
      selector.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
    };

    const selectedValues = () => {
      const data = new FormData(form);
      return {
        room: data.getAll('room'),
        property_use: data.get('property_use') || '',
        water: data.get('water') || '',
        priority: data.get('priority') || '',
        budget: data.get('budget') || '',
        look: data.get('look') || '',
        special: data.getAll('special')
      };
    };

    const typeMeta = (type) => {
      const source = hub.querySelector(`[data-type-card="${type}"]`);
      return {
        title: source?.dataset.typeTitle || type.replaceAll('_', ' '),
        url: source?.dataset.typeUrl || ''
      };
    };

    const resultCard = (item, primary, rank) => {
      const { title, url } = typeMeta(item.type);
      const reasons = Array.isArray(item.reasons) ? item.reasons : [];
      const cautions = Array.isArray(item.cautions) ? item.cautions : [];
      const cost = item.cost || null;

      const article = document.createElement('article');
      article.className = primary ? 'rf-fbh__result-card' : 'rf-fbh__ranked-card';
      if (!primary && rank === 2) article.classList.add('is-second-choice');

      const titleWrap = document.createElement('div');
      titleWrap.className = 'rf-fbh__ranked-heading';
      if (!primary) {
        const rankLabel = document.createElement('span');
        rankLabel.className = 'rf-fbh__rank-label';
        rankLabel.textContent = rank === 2 ? 'Second choice' : `#${rank}`;
        titleWrap.append(rankLabel);
      }
      const titleElement = document.createElement(primary ? 'h3' : 'h4');
      titleElement.textContent = title;
      titleWrap.append(titleElement);
      article.append(titleWrap);

      if (primary) {
        const points = document.createElement('div');
        points.className = 'rf-fbh__result-points';
        const label = document.createElement('strong');
        label.className = 'rf-fbh__result-label';
        label.textContent = 'Why it fits';
        const list = document.createElement('ul');
        (reasons.length ? reasons : ['A balanced match for the priorities you selected']).slice(0, 3).forEach((reason) => {
          const li = document.createElement('li');
          li.textContent = reason;
          list.append(li);
        });
        points.append(label, list);
        article.append(points);

        if (cautions.length) {
          const cautionWrap = document.createElement('div');
          cautionWrap.className = 'rf-fbh__result-points rf-fbh__result-points--caution';
          const cautionLabel = document.createElement('strong');
          cautionLabel.className = 'rf-fbh__result-label';
          cautionLabel.textContent = 'Things to consider';
          const cautionList = document.createElement('ul');
          cautions.slice(0, 2).forEach((caution) => {
            const li = document.createElement('li');
            li.textContent = caution;
            cautionList.append(li);
          });
          cautionWrap.append(cautionLabel, cautionList);
          article.append(cautionWrap);
        }
      } else {
        const details = document.createElement('div');
        details.className = 'rf-fbh__ranked-details';

        const good = document.createElement('div');
        good.className = 'rf-fbh__ranked-points';
        const goodHeading = document.createElement('strong');
        goodHeading.textContent = 'Good for your needs';
        const goodList = document.createElement('ul');
        (reasons.length ? reasons : ['A possible option depending on the exact product']).slice(0, 2).forEach((reason) => {
          const li = document.createElement('li');
          li.textContent = reason;
          goodList.append(li);
        });
        good.append(goodHeading, goodList);

        const bad = document.createElement('div');
        bad.className = 'rf-fbh__ranked-points rf-fbh__ranked-points--caution';
        const badHeading = document.createElement('strong');
        badHeading.textContent = 'A few things to keep in mind';
        const badList = document.createElement('ul');
        (cautions.length ? cautions : ['No major concerns.']).slice(0, 2).forEach((caution) => {
          const li = document.createElement('li');
          li.textContent = caution;
          badList.append(li);
        });
        bad.append(badHeading, badList);
        details.append(good, bad);
        article.append(details);
      }

      if (cost) {
        const costGuide = document.createElement('div');
        costGuide.className = 'rf-fbh__cost-guide';
        const costHeading = document.createElement('strong');
        costHeading.textContent = 'Cost guide';
        const material = document.createElement('span');
        material.textContent = `Material: ${cost.material} · ${cost.materialText}`;
        const installation = document.createElement('span');
        installation.textContent = `Installation: ${cost.installation}`;
        const note = document.createElement('small');
        note.textContent = 'Guide only — exact product and site conditions can change the final price.';
        costGuide.append(costHeading, material, installation, note);
        article.append(costGuide);
      }

      if (url) {
        const link = document.createElement('a');
        link.className = 'button button--secondary';
        link.href = url;
        link.textContent = `View ${title}`;
        article.append(link);
      }

      return article;
    };

    const calculate = async () => {
      const originalText = next.textContent;
      next.disabled = true;
      next.textContent = 'Finding matches…';
      error.hidden = true;

      try {
        const response = await fetch(recommendationEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ answers: selectedValues() })
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok || !data.ok || !data.primary?.type) throw new Error('Recommendation unavailable');

        hub.querySelector('[data-result-kicker]').textContent = data.kicker || 'Strongest match based on your priorities';
        hub.querySelector('[data-result-heading]').textContent = 'Your primary match';
        hub.querySelector('[data-result-summary]').textContent = data.summary || 'These suggestions are based on the priorities you selected. Review each range and speak with our team if you need project-specific advice.';

        const decisionNote = hub.querySelector('[data-result-decision]');
        if (decisionNote) {
          const decisionText = String(data.decisionText || '').trim();
          decisionNote.hidden = !decisionText;
          decisionNote.textContent = decisionText;
        }

        hub.querySelector('[data-primary-results]').replaceChildren(resultCard(data.primary, true, 1));
        const alternatives = Array.isArray(data.alternatives) ? data.alternatives : [];
        hub.querySelector('[data-ranked-list]')?.replaceChildren(...alternatives.map((item, index) => resultCard(item, false, index + 2)));

        form.hidden = true;
        results.hidden = false;
        renderReview(true);
        results.focus();
      } catch (_err) {
        error.textContent = 'We couldn’t calculate your matches just now. Please try again.';
        error.hidden = false;
      } finally {
        next.disabled = false;
        next.textContent = originalText;
      }
    };

    const currentAnswered = () => Boolean(questions[step].querySelector('input:checked'));

    hub.querySelectorAll('[data-selector-start]').forEach((button) => button.addEventListener('click', reset));
    hub.querySelectorAll('[data-selector-reset]').forEach((button) => button.addEventListener('click', reset));

    reviewMobileToggle?.addEventListener('click', () => {
      const collapsed = review.classList.toggle('is-mobile-collapsed');
      reviewMobileToggle.setAttribute('aria-expanded', String(!collapsed));
      if (reviewMobileAction) reviewMobileAction.textContent = collapsed ? 'Review' : 'Hide';
    });

    reviewList.addEventListener('click', (event) => {
      const edit = event.target.closest('[data-selector-edit]');
      if (!edit) return;
      const targetStep = Number(edit.dataset.selectorEdit);
      if (!Number.isInteger(targetStep)) return;
      editingFromReview = true;
      returnToResults = !results.hidden;
      returnStep = step;
      form.hidden = false;
      results.hidden = true;
      showStep(targetStep);
    });

    back.addEventListener('click', () => {
      if (editingFromReview) {
        const goResults = returnToResults;
        const oldStep = returnStep;
        editingFromReview = false;
        if (goResults) calculate(); else showStep(oldStep);
        return;
      }
      showStep(step - 1);
    });

    next.addEventListener('click', async () => {
      if (!currentAnswered()) {
        error.textContent = 'Please choose an answer to continue.';
        error.hidden = false;
        questions[step].querySelector('input')?.focus();
        return;
      }

      if (editingFromReview) {
        const goResults = returnToResults;
        const oldStep = returnStep;
        editingFromReview = false;
        renderReview();
        if (goResults) await calculate(); else showStep(oldStep);
        return;
      }

      if (step < questions.length - 1) showStep(step + 1);
      else await calculate();
    });

    form.querySelectorAll('input[name="room"]').forEach((input) => input.addEventListener('change', () => {
      const wholeHome = form.querySelector('input[name="room"][value="whole_home"]');
      if (input === wholeHome && input.checked) {
        form.querySelectorAll('input[name="room"]:not([value="whole_home"])').forEach((item) => { item.checked = false; });
      } else if (input !== wholeHome && input.checked && wholeHome) {
        wholeHome.checked = false;
      }
      renderReview();
    }));

    form.querySelectorAll('input[name="special"]').forEach((input) => input.addEventListener('change', () => {
      const none = form.querySelector('input[name="special"][value="none"]');
      if (input === none && input.checked) {
        form.querySelectorAll('input[name="special"]:not([value="none"])').forEach((item) => { item.checked = false; });
      } else if (input !== none && input.checked && none) {
        none.checked = false;
      }
      renderReview();
    }));

    form.addEventListener('change', () => {
      renderReview();
      renderScoreDebug();
    });

    // Menu links open the existing selector without creating a second questionnaire.
    const openFromMenu = () => {
      if (window.location.hash === '#rf-help-me-choose') reset();
    };
    window.addEventListener('hashchange', openFromMenu);
    openFromMenu();
  });
})();